export const removeItemFromShoppingBag = (id, item, catEntry, orderId, quantity, price) => {
	var ajaxUrl = '/webapp/wcs/stores/servlet/OrderItemDelete?';

	ajaxUrl +=
		'orderItemId=' +
		item +
		'&orderId=' +
		orderId +
		'&updatePrices=1&storeId=301&catalogId=301&langId=-1&calculationUsageId=-1&productId=' +
		catEntry +
		'&errorViewName=OrderItemDisplayView';
	ajaxUrl += '&URL=OrderCalculate%3FURL%3DOrderItemDisplay%26location%3DMyDillards';

	$.ajax({
		type: 'POST',
		url: ajaxUrl,
		dataType: 'json',
		success: function (data, textStatus) {
			$('#' + id).remove();
			if ($('.shopping-bag-wrapper tbody').children().length <= 0) {
				$('#myDillardsDropdownDynamic').html('<div class="emptyMessage">Your Shopping Bag is empty</div>');
			}
			return false;
		},
		error: function (jqXHR, textStatus, errorThrown) {
			var ajaxUrl2 = '/webapp/wcs/stores/servlet/OrderItemDelete?';

			ajaxUrl2 +=
				'orderItemId=' +
				item +
				'&orderId=' +
				orderId +
				'&updatePrices=1&storeId=301&catalogId=301&langId=-1&calculationUsageId=-1&productId=' +
				catEntry +
				'&errorViewName=OrderItemDisplayView';
			ajaxUrl2 += '&URL=OrderCalculate%3FURL%3DOrderItemDisplay';
			window.parent.location = ajaxUrl2;
			return false;
		},
	});
};
